// src/pages/TermosUso.jsx
import React from "react";
import { siteConfig } from "@/lib/siteConfig";

export default function TermosUso() {
  return (
    <main
      id="conteudo"
      className="container"
      style={{
        display: "grid",
        gap: "2rem",
        paddingTop: "2rem",
        paddingBottom: "2rem",
      }}
    >
      <section className="card">
        <h1 style={{ marginTop: 0 }}>Termos de Uso</h1>
        <p className="hero-sub" style={{ color: "var(--muted)" }}>
          Bem-vindo ao site <strong>{siteConfig?.nome || "CLEH TECH"}</strong>.  
          Ao utilizar nossos serviços, você concorda com os termos descritos
          abaixo.
        </p>

        <h2>1. Aceitação dos Termos</h2>
        <p>
          Ao acessar este site, você declara ter lido, entendido e aceitado os
          presentes Termos de Uso. Caso não concorde, pedimos que não utilize
          nossos serviços.
        </p>

        <h2>2. Uso do Site</h2>
        <p>
          Você concorda em utilizar o site apenas para fins legais, não
          violando direitos de terceiros nem comprometendo o funcionamento do
          sistema.
        </p>

        <h2>3. Responsabilidade</h2>
        <p>
          Embora busquemos manter as informações atualizadas,{" "}
          {siteConfig?.nome || "CLEH TECH"} não se responsabiliza por eventuais
          erros, interrupções ou indisponibilidade temporária do site.
        </p>

        <h2>4. Propriedade Intelectual</h2>
        <p>
          Todos os conteúdos (textos, imagens, logotipos, código e layout) são
          de propriedade de {siteConfig?.nome || "CLEH TECH"} ou de seus
          licenciadores, protegidos pelas leis de direitos autorais e marcas.
        </p>

        <h2>5. Alterações</h2>
        <p>
          Reservamo-nos o direito de alterar estes Termos de Uso a qualquer
          momento. O uso contínuo do site após mudanças implica na aceitação das
          novas condições.
        </p>

        <h2>6. Contato</h2>
        <p>
          Para dúvidas sobre os Termos de Uso, entre em contato pelo e-mail:{" "}
          <a
            href={`mailto:${siteConfig?.contato?.email || "contato@clehtech.com"}`}
            style={{ color: "var(--text)" }}
          >
            {siteConfig?.contato?.email || "contato@clehtech.com"}
          </a>
          .
        </p>
      </section>
    </main>
  );
}
